import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { Card } from '../ui/Card';
import { Icon } from '../ui/Icon';
import { Stars } from '../ui/Stars';
import { Picture } from '../ui/Picture';
import { Button } from '../ui/Button';
import { CarouselTrack, CarouselDots } from '../ui/Carousel';
import { useCarousel } from '../../hooks/useCarousel';
import { testimonials } from '../../data/landing';
import styles from './Testimonials.module.css';

export function Testimonials() {
  const { trackRef, index, count, goTo } = useCarousel();

  return (
    <Section id="testimonials" tone="alt">
      <SectionHeader
        eyebrow={testimonials.eyebrow}
        title={testimonials.title}
        subtitle={testimonials.subtitle}
      />

      <CarouselTrack trackRef={trackRef} bleed aria-label="Customer testimonials">
        {testimonials.items.map((t) => (
          <Card key={t.name} elevation="raised" className={styles.card} as="article">
            <Icon name="quote" size={40} className={styles.quoteMark} />
            <p className={styles.quote}>{t.quote}</p>

            <div className={styles.foot}>
              <div className={styles.person}>
                <Picture name={t.avatar} alt="" sizes="56px" fill className={styles.avatar} />
                <div>
                  <p className={styles.name}>{t.name}</p>
                  <p className={styles.role}>{t.role}</p>
                </div>
              </div>

              <div className={styles.rating}>
                <Stars value={t.rating} />
                <span className={styles.ratingValue}>{t.rating} Ratings</span>
              </div>
            </div>
          </Card>
        ))}
      </CarouselTrack>

      <CarouselDots count={count} index={index} goTo={goTo} label="testimonial" />

      <div className={styles.cta}>
        <Button to={testimonials.cta.to} icon="arrow-right-circle">
          {testimonials.cta.label}
        </Button>
      </div>
    </Section>
  );
}
